import { ComboBoxOption } from '../../../../components/form/controls/ComboBox';

function SelectedRoles(filters: ComboBoxOption[]) {
  let roleFilters: string[] = [];
  if (!filters) {
    return [];
  }
  for (let i = 0; i < filters.length; i++) {
    roleFilters.push(filters[i].label);
  }
  return roleFilters;
}

export default SelectedRoles;
